<template>
<canvas ref="myChart" width="50" height="50"></canvas>
</template>

<script>
import Chart from 'chart.js'
import _ from 'underscore'

export default {
    data () {
        return {
            chart: null
        }
    },
    props: [ 'wins', 'losses' ],
    watch: {
        wins (oldVal, newVal) {
            this.render()
        },
        losses (oldVal, newVal) {
            this.render()
        }
    },
    created () {
        this.render()
    },
    methods: {
        render () {
            if (!this.$refs.myChart) {
                return
            }

            const dataset = {
                data: [ this.wins || 0, this.losses || 0 ],
                backgroundColor: [ '#66ff84', '#ff6666' ]
            }

            // Build graph
            if (!this.chart) {
                var ctx = this.$refs.myChart
                this.chart = new Chart(ctx, {
                    type: 'doughnut',
                    data: {
                        datasets: [ dataset ],
                        labels: [ 'Siege', 'Niederlagen' ]
                    },
                    options: {
                        legend: { display: false },
                        response: false
                    }
                })
            // Update existing chart
            } else {
                this.chart.data.datasets = [ dataset ]
                this.chart.update()
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// pie-chart.vue?790959a7